<template>
	<v-dialog
		v-model="fileMetaEditorDialog"
		fullscreen
		scrollable
		hide-overlay
		transition="dialog-bottom-transition"
		persistent
	>
		<!-- @keydown.esc="logEsc($event)" -->
		<v-card>
			<v-toolbar>
				<v-btn icon @click="closeDialog">
					<v-icon>close</v-icon>
				</v-btn>
				<div class="">
					<v-toolbar-title>
						{{ selectedFile.originalFilename }} -
						{{ selectedFile.filename }}
					</v-toolbar-title>
					<div v-if="selectedFile && selectedFile.subject">
						{{ selectedFile.subject }} ( {{selectedFile.sender}} )
					</div>
				</div>
				<template v-slot:extension>
					<v-tabs v-model="model" slider-color="yellow" align-with-title grow>
						<v-tab v-for="i in tabItems" :key="i.tabId" :href="`#${i.tabId}`">{{
							i.name
						}}</v-tab>
					</v-tabs>
				</template>
			</v-toolbar>
			<v-tabs-items v-model="model">
				<v-tab-item v-for="i in tabItems" :key="i.tabId" :value="i.tabId">
					<v-card flat>
						<v-card-text>
							<component
								@switchTab="goToTab"
								:dataProp="i.props"
								:isActiveTab="model === i.tabId"
								v-bind:is="i.component"
								v-bind="{
									...i.props,
								}"
							/>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-card>
	</v-dialog>
</template>

<script>
import FileViewer from './fileViewer';
import FileMetaEditor from './fileMetaEditor';
import JSONViewer from './jsonViewer';
import LogViewer from './logViewer';
import mailMetaMixin from '../../mixins/mailMetaMixin';
import { mapGetters, mapMutations, mapActions } from 'vuex';
export default {
	components: {
		FileViewer,
		FileMetaEditor,
		JSONViewer,
		LogViewer,
	},
	mixins: [mailMetaMixin],
	data() {
		return {
			tabItems: [
				{
					name: 'Current File',
					tabId: 'tab-1',
					component: 'FileViewer',
					props: {},
				},
				{
					name: 'Stockist Meta',
					tabId: 'tab-2',
					component: 'FileMetaEditor',
					props: {},
				},
				{
					name: 'Transformed',
					tabId: 'tab-3',
					component: 'JSONViewer',
					props: {
						renderMode: 'transformed',
					},
				},
				{
					name: 'Logs',
					tabId: 'tab-4',
					component: 'LogViewer',
					props: {},
				},
			],
			model: 'tab-1',
		};
	},
	methods: {
		...mapActions('fileExtraction', ['unlockFile']),
		...mapMutations('identifyStockist', ['closeFileMetaDialog']),
		logEsc(e) {
			// console.log("ESC Pressed");
			e.preventDefault();
		},
		goToTab(tabId) {
			this.model = tabId;
		},
		closeDialog() {
			this.unlockFile(this.selectedFile._id).then(data => {
				if (!data) {
					this.closeFileMetaDialog();
				}
			});
		},
		checkAndSwitchToStockistMeta() {
			// Check if file has AI predicted stockist ID
			if (
				this.selectedFile &&
				this.selectedFile.AI_predicted_stockist_id &&
				this.selectedFile.AI_predicted_stockist_id.trim() !== ''
			) {
				// Switch to Stockist Meta tab
				this.model = 'tab-2';
			}
		},
	},
	mounted() {
		// Check initially when modal is mounted if we should switch to Stockist Meta tab
		this.checkAndSwitchToStockistMeta();
	},
	computed: {
		...mapGetters('identifyStockist', ['fileMetaEditorDialog', 'selectedFile']),
	},
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
</style>